<div #contentDiv class="max-w-lg mx-auto flex-col">
  <div class="h-20"></div>
  <div class="flex flex-col bg-theme-surface rounded-t-3xl min-h-[calc(100dvh-5rem)]">
    <!-- 1. Header -->
    <div class="flex flex-row pt-6 px-4 pb-4 items-center">
      <i class="fas fa-check-circle text-[2rem] text-theme-text"></i>
      <div class="ml-2 text-theme-text text-2xl break-words w-[calc(100%-3rem)]">
        {{ getString('Tack för din betalning!') }}
      </div>
    </div>

    <!-- 2. Receipt section -->
    <div class="flex-1 flex flex-col justify-evenly h-full gap-8">
      <div class="mx-16 relative drop-shadow-lg">
        <div class="">
          <div class="w-full text-theme-receipt-bg">
            <svg class="w-full h-2 bg-transparent" viewBox="0 0 100 20" preserveAspectRatio="none">
              <polygon
                points="0,20 5,0 10,20 15,0 20,20 25,0 30,20 35,0 40,20 45,0 50,20 55,0 60,20 65,0 70,20 75,0 80,20 85,0 90,20 95,0 100,20"
                fill="currentColor"/>
            </svg>
          </div>
          <div class="bg-theme-receipt-bg" (click)="navReceipt()">
            <app-receipt-display *ngIf="receiptKey" [receiptKey]="receiptKey" [strip]="true">
            </app-receipt-display>
          </div>
          <div class="w-full text-theme-receipt-bg">
            <svg class="w-full h-2 bg-transparent" viewBox="0 0 100 20" preserveAspectRatio="none">
              <polygon
                points="0,0 5,20 10,0 15,20 20,0 25,20 30,0 35,20 40,0 45,20 50,0 55,20 60,0 65,20 70,0 75,20 80,0 85,20 90,0 95,20 100,0"
                fill="currentColor"/>
            </svg>
          </div>
          <div class="absolute -right-5 -top-2">
            <app-circle-button [icon]="'fa-arrow-up-right-from-square'" size="10" type="solid" fontSize="base"
                               (onClick)="navReceipt()"></app-circle-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Review rating section -->
    @if (showReview) {
      <div class="flex flex-col items-center px-6 mt-8">
        @if (showThankYouState) {
          <div class="w-full max-w-xs">
            <app-action-button
              [text]="getString('Betygsätt på Google')"
              icon="fa-arrow-up-right-from-square"
              [chevron]="false"
              (onClick)="openGoogleReview()">
            </app-action-button>
          </div>
        } @else {
          <div class="text-xl font-bold text-theme-text text-center">
            {{ reviewService.reviewSubmitted ? getString(reviewService.thankYouText) : getString(reviewService.reviewText) }}
          </div>
          <div class="mt-4">
            <app-star-rating [rating]="reviewService.overallRating"
              (ratingChange)="onOverallRatingSelected($event)" size="lg">
            </app-star-rating>
          </div>
        }
      </div>
    }

    <!-- 3. Footer -->
    <div class="mt-auto p-6 flex flex-col items-center">
      <div class="space-y-4 font-bold mt-4 text-theme-text" *ngIf="showProgress">
        {{ leftMessage }}
        <i *ngIf="!stillItemsToPay" class="ml-2 fas fa-thumbs-up"></i>
      </div>
      <div class="mt-4 w-full" *ngIf="showProgress">
        <app-progress-bar [progress]="progress!"></app-progress-bar>
      </div>

      <!-- Question text -->
      <div class="text-lg mt-6 text-theme-text" *ngIf="stillItemsToPay">{{ getString('Glömde du att betala för något?') }}</div>
      <div class="mt-2" *ngIf="stillItemsToPay">
        <app-light-icon-button
          icon="fa-receipt"
          [text]="getString('Se bordsnotan')"
          (onClick)="navLivesplit()">
        </app-light-icon-button>
      </div>

      <div class="mt-8 w-full">
        <app-border-icon-button
          icon="fa-chevron-left"
          [text]="getString('Tillbaka till menyn')"
          (onClick)="backToMenu()">
        </app-border-icon-button>
      </div>
    </div>
  </div>
</div>
